import { translate } from "../../util/translate"

export const cityHeaders = [
  {
    text: translate['city.label.status'],
    value: 'enabled',
    width: '5%',
  },
  {
    text: translate['city.label.name'],
    value: 'name',
    width: '15%',
  },
  {
    text: translate['city.label.state'],
    value: 'state.name',
    width: '20%',
  },
  { value: 'actions', align: 'end', width: '3%' }
]
